import { useEffect, useRef } from 'react';
import styles from './form.module.scss';
import { ConversationalForm } from 'conversational-form';
import axios from 'axios';

function Form() {
  let cf = null;
  const ref = useRef(null);
  const formFields = [
    {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      'cf-questions': 'Hi there! What\'s your name?'
    },
    {
      'tag': 'fieldset',
      'name': 'intro',
      'cf-questions': 'Nice to meet you, {firstname}! As you\'ve already noticed, I’m a freelance Product Designer and Journalist.&&What can I help you with? What are you looking for?',

      "children": [
        {
          "tag": "input",
          "type": "radio",
          "cf-label": "Product Design",
          "value": "product_design",
          'name': 'intro',
        },
        {
          "tag": "input",
          "type": "radio",
          'name': 'intro',
          "cf-label": "Journalism",
          "value": "journalism"
        },
      ]
    },
    {
      'tag': 'input',
      "name": "journalism_more",
      'cf-questions': 'Fine! Tell me more about your subject…',
      'cf-conditional-intro': 'journalism'
    },
    {
      'tag': 'fieldset',
      'cf-questions': 'Fine! What kind of project do you want to set up?',
      'cf-conditional-intro': 'product_design',
      "children": [
        {
          "tag": "input",
          "type": "radio",
          "cf-label": "Web Design",
          "value": "web_design",
          'name': 'type',
          'cf-conditional-intro': 'product_design',
        },
        {
          "tag": "input",
          "type": "radio",
          'name': 'type',
          "cf-label": "Product Design",
          "value": "product_design",
          'cf-conditional-intro': 'product_design',
        },
        {
          "tag": "input",
          "type": "radio",
          'name': 'type',
          "cf-label": "Other",
          "value": "other",
          'cf-conditional-intro': 'product_design',
        },
      ]
    },
    {
      'tag': 'fieldset',
      'cf-questions': 'What can I help you with?',
      'cf-conditional-intro': 'product_design',
      "children": [
        {
          "tag": "input",
          "type": "radio",
          "cf-label": "Product idea ideation & validation",
          "value": "product_ideation",
          'name': 'type2',
          'cf-conditional-intro': 'product_design',
        },
        {
          "tag": "input",
          "type": "radio",
          'name': 'type2',
          "cf-label": "UX / UI Design",
          'cf-conditional-intro': 'product_design',
          "value": "ux_ui"
        },
        {
          "tag": "input",
          "type": "radio",
          'name': 'type2',
          "cf-label": "I'm not sure...",
          'cf-conditional-intro': 'product_design',
          "value": "not_sure"
        },
      ]
    },
    {
      'tag': 'fieldset',
      'cf-questions': 'I see... &&What are the main challenges you’re facing right now?',
      'cf-conditional-intro': 'product_design',
      "children": [
        {
          "tag": "input",
          "type": "radio",
          "cf-label": "Validating my product idea",
          "value": "product_idea",
          'cf-conditional-intro': 'product_design',
          'name': 'type3',
        },
        {
          "tag": "input",
          "type": "radio",
          "cf-label": "Creating an MVP",
          "value": "mvp",
          'cf-conditional-intro': 'product_design',
          'name': 'type3',
        },
        {
          "tag": "input",
          "type": "radio",
          "cf-label": "Scale an existing product",
          "value": "scale_product",
          'cf-conditional-intro': 'product_design',
          'name': 'type3',
        },
        {
          "tag": "input",
          "type": "radio",
          "cf-label": "Driving more sales",
          "value": "more_sales",
          'cf-conditional-intro': 'product_design',
          'name': 'type3',
        },
        {
          "tag": "input",
          "type": "radio",
          "cf-label": "Other",
          "value": "other",
          'cf-conditional-intro': 'product_design',
          'name': 'type3',
        },
      ]
    },
    {
      'tag': 'fieldset',
      'cf-questions': 'How can I contact you?',
      "children": [
        {
          "tag": "input",
          "type": "radio",
          "cf-label": "E-mail",
          "value": "email",
          'name': 'contact_method',
        },
        {
          "tag": "input",
          "type": "radio",
          "cf-label": "Phone",
          "value": "phone",
          'name': 'contact_method',
        }
      ]
    },
    {
      'tag': 'input',
      'pattern': '.+\@.+\..+',
      'cf-conditional-contact_method': 'email',
      'cf-error': 'E-mail not correct',
      'cf-questions': 'Please write down your email address...',
    },
    {
      'tag': 'input',
      'cf-conditional-contact_method': 'phone',
      'cf-questions': 'Please write down your phone number...',
    },
  ];

    	

  useEffect(function mount() {
    if (typeof window === 'undefined') return;
    cf = ConversationalForm.startTheConversation({
      options: {
        robotImage: 'data:image/png;base64,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',
        theme: 'light',
        submitCallback: submitCallback,
        preventAutoFocus: true,
        // loadExternalStyleSheet: false
      },
      tags: formFields,
    });

    ref.current.appendChild(cf.el);

    return function unMount() {
      cf.remove();
    };
  }, []);

  function submitCallback() {
    var formDataSerialized = cf.getFormData(true);
    console.log("Formdata, obj:", formDataSerialized);
    cf.addRobotChatResponse("Thank you! I'll contact you as soon as possible.");

    axios.post('/send.php', {data: formDataSerialized}).then(r => {
      cf.addRobotChatResponse("Have a nice day!");
    })
  }

  return (<div className={styles.form} id="contact">
    <div className={styles.form__title} data-aos="fade-up">
      Let’s talk.
      <strong>Have a project in mind?</strong>
    </div>
    <div className={styles.form__box} data-aos="fade-up">
      <div ref={ref} />
    </div>
  </div>)
}

export default Form;